<div class="validation">
  {{ errorMessage | translate }}
</div>
